import * as React from 'react';

export default function Dashboard(params) {
	return (
		<div>
			<p>Dashboard data ...</p>
		</div>
	);
}
